export default __webpack_public_path__ + "static/media/logo.18d3644d.png";